export default __webpack_public_path__ + "static/media/tiddingthings.260c1dbf.png";